module.exports = __webpack_public_path__ + "img/img24.781ab6b4.svg";